export const ACL_LIST = 'Acl/ACL_LIST';
export const ACL_LIST_SET_DATA = 'Acl/ACL_LIST_SET_DATA';

